import { useHasOrganizationSettings } from "src/hooks/use-has-organization-settings";
import { usePersonalization } from "src/hooks/use-personalization";
import { useShouldSuppressFeatureAnnouncements } from "src/hooks/use-should-suppress-feature-announcements";
import { useAgentsOptOutEnabled } from "src/pages/agents/hooks/use-agents-opt-out-enabled";
import { useShouldShowAgentsTos } from "src/pages/agents/hooks/use-should-show-agents-tos";

export const useShouldShowAiFeaturesAnnouncement = () => {
  const isAgentsOptOutEnabled = useAgentsOptOutEnabled();
  const shouldSuppressAnnouncements = useShouldSuppressFeatureAnnouncements();
  const { hasAccess: isAdmin, isLoading } = useHasOrganizationSettings();
  // Suppress the announcement when agents ToS is visible to avoid a double-prompt.
  const { shouldShowGlobalAgentsTos } = useShouldShowAgentsTos();
  const { value: isDismissed, setLocal: setIsDismissed } =
    usePersonalization<boolean>({
      key: "agents.ai-features-announcement-dismissed",
      initialValue: false,
      useWorkspace: false,
    });

  return {
    isAdmin,
    setIsDismissed,
    shouldShow:
      isAgentsOptOutEnabled &&
      !isDismissed &&
      !isLoading &&
      !shouldShowGlobalAgentsTos &&
      !shouldSuppressAnnouncements,
  };
};
